import { render, staticRenderFns } from "./SubscriptionEstimate.vue?vue&type=template&id=536f0fb2&scoped=true&"
import script from "./SubscriptionEstimate.vue?vue&type=script&lang=js&"
export * from "./SubscriptionEstimate.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionEstimate.vue?vue&type=style&index=0&id=536f0fb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536f0fb2",
  null
  
)

/* custom blocks */
import block0 from "./SubscriptionEstimate.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VIcon,VSimpleTable})
